export default __webpack_public_path__ + "static/pascal-45b64ec1420e662ca3e074f5402a14ca.jpg";